import { camelCase, startCase } from 'lodash'

export const camelcaseKeys = (object) => convertKeys(object, camelCase)

export const pascalcaseKeys = (object) => convertKeys(object, (value) => startCase(camelCase(value)).replace(/ /g, ''))

export const convertKeys = (object, converter) => {
  if (Array.isArray(object)) {
    return object.map(item => convertKeys(item, converter))
  } else if (object !== null && object.constructor === Object) {
    return Object.keys(object).reduce(
      (result, key) => ({
        ...result,
        [converter(key)]: convertKeys(object[key], converter)
      }),
      {}
    )
  }

  return object
}
